angular.module("dettaglio.components", ['app.services']).component("dettaglio", {
    templateUrl: "ng/components/dettaglioContratto/dettaglio/dettaglio.view.html",
    bindings: {
        contractData: "<",
        isLoading: "<"
    },
    controllerAs: "dettaglioCtrl",
    controller: function DettaglioContratto() {
        var self = this;

        self.$onInit = function () {
            
            self.isLoading = self.isLoading;

        };

    }
});